import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { textType } from 'resources/AppTexts';
import { useState } from 'react';
import { Grid, IconButton, Typography } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { AppColors } from 'resources/AppColors';
import { useDispatch, useSelector } from 'react-redux';
import DialogMonitoring from 'components/DialogMonitoring';
import {
  CommonTexts,
  LabelsLogOut,
  ProfessionalsTableModals,
  professionalTexts,
} from 'locale/es';
import TextMonitoring from 'components/TextMonitoring';
import CustomDialog from 'components/Dialogs/MasterDialog';
import ProfessionalToDisplay from './ProfessionalToDisplay';
import {
  createProfessionalAction,
  deleteProfessionalAction,
  updateProfessionalAction,
} from 'redux/reducers/allProfessionalsReducer';
import Loader from 'components/Loader/Loader';
import NoDataTableBody from 'components/TableMonitoring/Body/NoDataTableBody';
import ProfessionalForm from './ProfessionalForm';
import { useFilterContext } from 'context/FilterContext';
import { useFilter } from 'hooks/useFilter';
import FilterTable from 'components/TableMonitoring/Toolbar/Filter';

const tableHeaders = [
  { name: CommonTexts.FULL_NAME, value: 'fullName' },
  { name: CommonTexts.EMAIL, value: 'email' },
  { name: CommonTexts.ORGANIZATION, value: 'organization' },
  { name: CommonTexts.PROFILE, value: 'profile' },
];
const ProfessionalsTable = ({ centerId }) => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedProfessional, setSelectedProfessional] = useState(null);

  const { selectedFilter, searchTerm } = useFilterContext();

  const dispatch = useDispatch();

  const { data, loading, error } = useSelector(
    ({ allProfessionals }) => allProfessionals
  );

  const adaptedTableHeaders = tableHeaders.map((header) => header.name);
  const { filteredData } = useFilter(data, adaptedTableHeaders);

  const handleShowDeleteModal = (professionalToDelete) => {
    if (professionalToDelete) {
      setSelectedProfessional(professionalToDelete);
    }
    setShowDeleteModal(!showDeleteModal);
  };

  const handleOnConfirmDeleteProfessional = () => {
    dispatch(deleteProfessionalAction(selectedProfessional.id));
    setShowDeleteModal(false);
    setSelectedProfessional(null);
  };

  const handleShowEditModal = (professional) => {
    if (professional.id) {
      setSelectedProfessional(professional);
    } else {
      setSelectedProfessional(null);
    }
    setShowEditModal(!showEditModal);
  };

  const handleShowAddModal = () => {
    setShowAddModal(!showAddModal);
  };

  if (loading) {
    return <Loader message={professionalTexts.LOADING} pt={32} />;
  }

  return (
    <>
      <FilterTable data={data} tableHeaders={tableHeaders} />
      <TableContainer component={Paper}>
        <Table aria-label='simple table'>
          <TableHead>
            <TableRow>
              {adaptedTableHeaders.map((header) => (
                <TableCell align='left' key={header}>
                  <Typography variant='subtitle'>{header}</Typography>
                </TableCell>
              ))}
              <TableCell align='center'>
                <IconButton onClick={handleShowAddModal} size='large'>
                  <AddCircleIcon sx={{ fill: AppColors.PRIMARY }} />
                </IconButton>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 && (
              <>
                {(selectedFilter && !searchTerm ? data : filteredData).map(
                  (professional) => (
                    <ProfessionalToDisplay
                      key={professional.id}
                      professional={professional}
                      handleShowEditModal={handleShowEditModal}
                      handleShowDeleteModal={handleShowDeleteModal}
                    />
                  )
                )}
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {data?.length === 0 && (
        <NoDataTableBody
          entity={centerId}
          noDataMessage={professionalTexts.NO_DATA}
        />
      )}
      {data?.length > 0 && filteredData?.length === 0 && searchTerm && (
        <NoDataTableBody
          entity={centerId}
          noDataMessage={professionalTexts.NO_DATA_FILTERS}
        />
      )}
      <CustomDialog
        title={ProfessionalsTableModals.CREATE_PROFESSIONAL}
        show={showAddModal}
        handleShow={handleShowAddModal}
      >
        <ProfessionalForm
          onSubmit={createProfessionalAction}
          setShowModal={setShowAddModal}
        />
      </CustomDialog>
      <CustomDialog
        title={ProfessionalsTableModals.EDIT_PROFESSIONAL}
        show={showEditModal}
        handleShow={handleShowEditModal}
      >
        <ProfessionalForm
          selectedProfessional={selectedProfessional}
          setShowModal={setShowEditModal}
          onSubmit={updateProfessionalAction}
        />
      </CustomDialog>
      {showDeleteModal && (
        <DialogMonitoring
          textCancelButton={LabelsLogOut.CANCEL}
          title={ProfessionalsTableModals.DELETE_PROFESSIONAL.TITLE}
          textConfirmButton={CommonTexts.DELETE}
          buttonColor={AppColors.RED}
          show={showDeleteModal}
          handleShow={handleShowDeleteModal}
          handleConfirm={handleOnConfirmDeleteProfessional}
        >
          <Grid>
            <TextMonitoring
              color={AppColors.PRIMARY}
              type={textType.BODY}
              text={ProfessionalsTableModals.DELETE_PROFESSIONAL.TEXT}
            />
          </Grid>
        </DialogMonitoring>
      )}
    </>
  );
};

export default ProfessionalsTable;
